import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { RQAPICall, HttpContentWithData, HttpResponse } from 'store/APIClient';
import { STALE_TIME } from 'business/constants';
import { ScopeTree } from 'routes/HumanResourcesModule/helpers/types';

/**
 * Hook to fetch all historicalOrgChartHr
 */
export const useHistoricalGetOrgChartHr = (): UseQueryResult<TreeT> => {
    return useQuery({
        queryKey: ['org_chart_hr'],
        queryFn: async () => {
            const getResponse: HttpResponse<HttpContentWithData<ScopeTree>> =
                await RQAPICall({
                    endpoint: 'auth/scope_tree/historical_org_chart_hr.tree',
                    method: 'GET',
                });

            return getResponse.content.data.treeValues;
        },

        staleTime: STALE_TIME,
        meta: {
            useGlobalOnError: true,
        },
    });
};
